import { FC, useEffect } from "react";
import styles from "./index.module.css";
import { Input } from "../inputs/inputs";

type Props = {
  observation: string;
  setObservation: (value: string) => void;
  readonly?: boolean;
  limitCharacters?: number;
};

const OrderObservation: FC<Props> = ({
  observation,
  setObservation,
  readonly,
  limitCharacters,
}) => {
  function setLimitObservarion() {
    if (limitCharacters && limitCharacters - observation?.length <= 0) {
      setObservation(observation.slice(0, limitCharacters));
    }
  }

  useEffect(() => {
    setLimitObservarion();
  }, [limitCharacters, observation?.length]);

  return (
    <div className={styles.content}>
      <div className={styles.main}>
        <h4>Observação</h4>
      </div>
      <div className={styles.finalize_order_details}>
        <Input
          inputAttr={{
            type: "textarea",
          }}
          label=""
          placeholder="comentario"
          backgroundColor="#FFFFFF"
          rows={5}
          value={observation}
          change={(value: string) => {
            setObservation(value);
          }}
          disabled={readonly}
        />
        {limitCharacters ? (
          observation?.length < limitCharacters ? (
            <span style={{ fontSize: "11px" }}>
              Quantidade de caracteres digitados: {observation?.length}/
              {limitCharacters}
            </span>
          ) : (
            <span className={styles.limit_value}>
              Limite máximo de caracteres atingido.
            </span>
          )
        ) : (
          <></>
        )}
        {/* { limitCharacters && limitCharacters > 0 &&
        <span className={styles.limit_value}>
          * Quantidade de caracteres restantes: {limitCharacters - observation?.length}
        </span>} */}
      </div>
    </div>
  );
};

export { OrderObservation };
